import { getSessionDuration } from 'application/session_duration'

SOPHIA.loginEvent = function(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "login",
    session_duration: getSessionDuration(),
    method: data.method,
    module_name: data.module_name
  });
}
